// @ts-nocheck 
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.8.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import {ApiClientConfig} from "app/modules/common/api/ApiClientConfig";
import {AuthorizedApiBase} from "app/modules/common/api/AuthorizedApiBase";import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import moment from 'moment';

export interface IDataProviderClient {
    getUserData(): Promise<UserInfo>;
}

export class DataProviderClient extends AuthorizedApiBase implements IDataProviderClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getUserData(signal?: AbortSignal): Promise<UserInfo> {
        let url_ = this.baseUrl + "/admin/DataProvider/GetUserData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserData(_response);
        });
    }

    protected processGetUserData(response: AxiosResponse): Promise<UserInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserInfo.fromJS(resultData200);
            return Promise.resolve<UserInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserInfo>(null as any);
    }
}

export interface ITenantManagementClient {
    getTenants(param: DataListGetParamsOfTenantAdminListFilters | null): Promise<DataListResultOfTenantAdminListModel>;
    getOrganizations(param: DataListGetParamsOfOrganizationListFilters | null): Promise<DataListResultOfOrganizationListModel>;
    createOrganization(model: OrganizationNewModel | null): Promise<void>;
    deleteOrganization(id: number): Promise<void>;
    getOrganizationDetails(id: number): Promise<OrganizationDetailsModel>;
    activateOrganization(id: number): Promise<void>;
    deactivateOrganization(id: number): Promise<void>;
    deleteServerNode(id: number): Promise<void>;
    setRecurringJobs(id: number): Promise<void>;
    runSylectusSync(id: number): Promise<void>;
    upgradeTenant(id: number): Promise<void>;
    getVerifiedDomains(id: number): Promise<string[]>;
    setVerifiedDomains(id: number, domains: string[] | null): Promise<void>;
}

export class TenantManagementClient extends AuthorizedApiBase implements ITenantManagementClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getTenants(param: DataListGetParamsOfTenantAdminListFilters | null, signal?: AbortSignal): Promise<DataListResultOfTenantAdminListModel> {
        let url_ = this.baseUrl + "/admin/TenantManagement/GetTenants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenants(_response);
        });
    }

    protected processGetTenants(response: AxiosResponse): Promise<DataListResultOfTenantAdminListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfTenantAdminListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfTenantAdminListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfTenantAdminListModel>(null as any);
    }

    getOrganizations(param: DataListGetParamsOfOrganizationListFilters | null, signal?: AbortSignal): Promise<DataListResultOfOrganizationListModel> {
        let url_ = this.baseUrl + "/admin/TenantManagement/GetOrganizations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizations(_response);
        });
    }

    protected processGetOrganizations(response: AxiosResponse): Promise<DataListResultOfOrganizationListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfOrganizationListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfOrganizationListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfOrganizationListModel>(null as any);
    }

    createOrganization(model: OrganizationNewModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/admin/TenantManagement/CreateOrganization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrganization(_response);
        });
    }

    protected processCreateOrganization(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteOrganization(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/admin/TenantManagement/DeleteOrganization/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteOrganization(_response);
        });
    }

    protected processDeleteOrganization(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getOrganizationDetails(id: number, signal?: AbortSignal): Promise<OrganizationDetailsModel> {
        let url_ = this.baseUrl + "/admin/TenantManagement/GetOrganizationDetails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizationDetails(_response);
        });
    }

    protected processGetOrganizationDetails(response: AxiosResponse): Promise<OrganizationDetailsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrganizationDetailsModel.fromJS(resultData200);
            return Promise.resolve<OrganizationDetailsModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationDetailsModel>(null as any);
    }

    activateOrganization(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/admin/TenantManagement/ActivateOrganization/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivateOrganization(_response);
        });
    }

    protected processActivateOrganization(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deactivateOrganization(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/admin/TenantManagement/DeactivateOrganization/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeactivateOrganization(_response);
        });
    }

    protected processDeactivateOrganization(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteServerNode(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/admin/TenantManagement/DeleteServerNode/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteServerNode(_response);
        });
    }

    protected processDeleteServerNode(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    setRecurringJobs(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/admin/TenantManagement/SetRecurringJobs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetRecurringJobs(_response);
        });
    }

    protected processSetRecurringJobs(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    runSylectusSync(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/admin/TenantManagement/RunSylectusSync/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRunSylectusSync(_response);
        });
    }

    protected processRunSylectusSync(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    upgradeTenant(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/admin/TenantManagement/UpgradeTenant/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpgradeTenant(_response);
        });
    }

    protected processUpgradeTenant(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getVerifiedDomains(id: number, signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/admin/TenantManagement/GetVerifiedDomains/{id}/verified-domains";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVerifiedDomains(_response);
        });
    }

    protected processGetVerifiedDomains(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    setVerifiedDomains(id: number, domains: string[] | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/admin/TenantManagement/SetVerifiedDomains/{id}/verified-domains";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(domains);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetVerifiedDomains(_response);
        });
    }

    protected processSetVerifiedDomains(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IUsersClient {
    getUsers(param: DataListGetParamsOfAdminUserListFilters | null): Promise<DataListResultOfUserListModel>;
    getOrganizationOwners(id: number): Promise<UserListModel[]>;
    impersonateOrganization(id: number): Promise<void>;
}

export class UsersClient extends AuthorizedApiBase implements IUsersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getUsers(param: DataListGetParamsOfAdminUserListFilters | null, signal?: AbortSignal): Promise<DataListResultOfUserListModel> {
        let url_ = this.baseUrl + "/admin/Users/GetUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: AxiosResponse): Promise<DataListResultOfUserListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfUserListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfUserListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfUserListModel>(null as any);
    }

    getOrganizationOwners(id: number, signal?: AbortSignal): Promise<UserListModel[]> {
        let url_ = this.baseUrl + "/admin/Users/GetOrganizationOwners/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizationOwners(_response);
        });
    }

    protected processGetOrganizationOwners(response: AxiosResponse): Promise<UserListModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserListModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserListModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserListModel[]>(null as any);
    }

    impersonateOrganization(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/admin/Users/ImpersonateOrganization/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImpersonateOrganization(_response);
        });
    }

    protected processImpersonateOrganization(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UserInfo implements IUserInfo {
    fullName?: string | undefined;
    userEmail?: string | undefined;
    isAdmin?: boolean;
    userType?: UserType;
    claims?: TenantClaims[] | undefined;
    adminClaims?: InternalClaims[] | undefined;
    tenantId?: number | undefined;
    pusherSettings?: PusherSettings | undefined;
    tenants?: NamedValueLong[] | undefined;

    constructor(data?: IUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["FullName"];
            this.userEmail = _data["UserEmail"];
            this.isAdmin = _data["IsAdmin"];
            this.userType = _data["UserType"];
            if (Array.isArray(_data["Claims"])) {
                this.claims = [] as any;
                for (let item of _data["Claims"])
                    this.claims!.push(item);
            }
            if (Array.isArray(_data["AdminClaims"])) {
                this.adminClaims = [] as any;
                for (let item of _data["AdminClaims"])
                    this.adminClaims!.push(item);
            }
            this.tenantId = _data["TenantId"];
            this.pusherSettings = _data["PusherSettings"] ? PusherSettings.fromJS(_data["PusherSettings"]) : <any>undefined;
            if (Array.isArray(_data["Tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["Tenants"])
                    this.tenants!.push(NamedValueLong.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FullName"] = this.fullName;
        data["UserEmail"] = this.userEmail;
        data["IsAdmin"] = this.isAdmin;
        data["UserType"] = this.userType;
        if (Array.isArray(this.claims)) {
            data["Claims"] = [];
            for (let item of this.claims)
                data["Claims"].push(item);
        }
        if (Array.isArray(this.adminClaims)) {
            data["AdminClaims"] = [];
            for (let item of this.adminClaims)
                data["AdminClaims"].push(item);
        }
        data["TenantId"] = this.tenantId;
        data["PusherSettings"] = this.pusherSettings ? this.pusherSettings.toJSON() : <any>undefined;
        if (Array.isArray(this.tenants)) {
            data["Tenants"] = [];
            for (let item of this.tenants)
                data["Tenants"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserInfo {
        const json = this.toJSON();
        let result = new UserInfo();
        result.init(json);
        return result;
    }
}

export interface IUserInfo {
    fullName?: string | undefined;
    userEmail?: string | undefined;
    isAdmin?: boolean;
    userType?: UserType;
    claims?: TenantClaims[] | undefined;
    adminClaims?: InternalClaims[] | undefined;
    tenantId?: number | undefined;
    pusherSettings?: PusherSettings | undefined;
    tenants?: NamedValueLong[] | undefined;
}

/** 1 = Internal 2 = Tenant */
export enum UserType {
    Internal = 1,
    Tenant = 2,
}

/** 0 = FullAccess 1 = OrganizationAdmin 2 = UsersListView 3 = UsersEdit 4 = RoleListView 5 = RoleEdit 6 = TenantListView 7 = DriverListView 8 = DriverEdit 9 = CarrierListView 10 = CarrierEdit 11 = IntegrationListView 12 = IntegrationEdit 13 = IntegrationUserSettingsEdit 14 = IntegrationUserSettingsView 15 = VehicleListView 16 = VehicleEdit 17 = OrderTaskEdit 18 = OrderTaskView 19 = EditVehicleAvailability 20 = DeleteFile 21 = TenantNew 22 = CompanyUser 23 = SettingsEditView 24 = RadarView 25 = BidListView 26 = BidWon 27 = BidForceWon 28 = BidReject 29 = BidCreate 30 = OrderListView 31 = OrderEdit 32 = OrderVehicle 33 = OrderDrivers 34 = OrderNew 35 = OrderDraft 36 = OrderReady 37 = OrderOnHold 38 = OrderProgress 39 = OrderCancel 40 = OrderComplete 41 = OrderClose 42 = OrderNotification 43 = CustomerEdit 44 = ContactEdit 45 = TelegramChannelEdit 46 = AccountingInvoicing 47 = AccountingPayments 48 = AccountingAdmin 49 = AccountingSummary 50 = TrackingDeviceEdit 51 = OrderQuoteListView 52 = OrderQuoteEdit 53 = OwnerAccountEdit 54 = OwnerAccountListView 55 = AccountPayout 56 = AccountPayoutAdmin 57 = MobileLogView 58 = Inbox 59 = RateSettingsEdit */
export enum TenantClaims {
    FullAccess = 0,
    OrganizationAdmin = 1,
    UsersListView = 2,
    UsersEdit = 3,
    RoleListView = 4,
    RoleEdit = 5,
    TenantListView = 6,
    DriverListView = 7,
    DriverEdit = 8,
    CarrierListView = 9,
    CarrierEdit = 10,
    IntegrationListView = 11,
    IntegrationEdit = 12,
    IntegrationUserSettingsEdit = 13,
    IntegrationUserSettingsView = 14,
    VehicleListView = 15,
    VehicleEdit = 16,
    OrderTaskEdit = 17,
    OrderTaskView = 18,
    EditVehicleAvailability = 19,
    DeleteFile = 20,
    TenantNew = 21,
    CompanyUser = 22,
    SettingsEditView = 23,
    RadarView = 24,
    BidListView = 25,
    BidWon = 26,
    BidForceWon = 27,
    BidReject = 28,
    BidCreate = 29,
    OrderListView = 30,
    OrderEdit = 31,
    OrderVehicle = 32,
    OrderDrivers = 33,
    OrderNew = 34,
    OrderDraft = 35,
    OrderReady = 36,
    OrderOnHold = 37,
    OrderProgress = 38,
    OrderCancel = 39,
    OrderComplete = 40,
    OrderClose = 41,
    OrderNotification = 42,
    CustomerEdit = 43,
    ContactEdit = 44,
    TelegramChannelEdit = 45,
    AccountingInvoicing = 46,
    AccountingPayments = 47,
    AccountingAdmin = 48,
    AccountingSummary = 49,
    TrackingDeviceEdit = 50,
    OrderQuoteListView = 51,
    OrderQuoteEdit = 52,
    OwnerAccountEdit = 53,
    OwnerAccountListView = 54,
    AccountPayout = 55,
    AccountPayoutAdmin = 56,
    MobileLogView = 57,
    Inbox = 58,
    RateSettingsEdit = 59,
}

/** 0 = FullAccess 1 = HangfireDashboard */
export enum InternalClaims {
    FullAccess = 0,
    HangfireDashboard = 1,
}

export class PusherSettings implements IPusherSettings {
    cluster?: string | undefined;
    appKey?: string | undefined;
    pusherNamespace?: string | undefined;
    channelAuthorization?: string | undefined;

    constructor(data?: IPusherSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cluster = _data["Cluster"];
            this.appKey = _data["AppKey"];
            this.pusherNamespace = _data["PusherNamespace"];
            this.channelAuthorization = _data["ChannelAuthorization"];
        }
    }

    static fromJS(data: any): PusherSettings {
        data = typeof data === 'object' ? data : {};
        let result = new PusherSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Cluster"] = this.cluster;
        data["AppKey"] = this.appKey;
        data["PusherNamespace"] = this.pusherNamespace;
        data["ChannelAuthorization"] = this.channelAuthorization;
        return data;
    }

    clone(): PusherSettings {
        const json = this.toJSON();
        let result = new PusherSettings();
        result.init(json);
        return result;
    }
}

export interface IPusherSettings {
    cluster?: string | undefined;
    appKey?: string | undefined;
    pusherNamespace?: string | undefined;
    channelAuthorization?: string | undefined;
}

export class NamedValueLong implements INamedValueLong {
    id?: number;
    name?: string | undefined;

    constructor(data?: INamedValueLong) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): NamedValueLong {
        data = typeof data === 'object' ? data : {};
        let result = new NamedValueLong();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data;
    }

    clone(): NamedValueLong {
        const json = this.toJSON();
        let result = new NamedValueLong();
        result.init(json);
        return result;
    }
}

export interface INamedValueLong {
    id?: number;
    name?: string | undefined;
}

export class DataListResultOfTenantAdminListModel implements IDataListResultOfTenantAdminListModel {
    items?: TenantAdminListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfTenantAdminListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(TenantAdminListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfTenantAdminListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfTenantAdminListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfTenantAdminListModel {
        const json = this.toJSON();
        let result = new DataListResultOfTenantAdminListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfTenantAdminListModel {
    items?: TenantAdminListModel[] | undefined;
    count?: number;
}

export class TenantListModel implements ITenantListModel {
    id?: number;
    name?: string | undefined;
    status?: TenantStatus;
    uSDOT?: number;
    eIN?: number;
    address?: Address | undefined;
    createdAt?: moment.Moment;
    isMaintenance?: boolean;

    constructor(data?: ITenantListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.status = _data["Status"];
            this.uSDOT = _data["USDOT"];
            this.eIN = _data["EIN"];
            this.address = _data["Address"] ? Address.fromJS(_data["Address"]) : <any>undefined;
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
            this.isMaintenance = _data["IsMaintenance"];
        }
    }

    static fromJS(data: any): TenantListModel {
        data = typeof data === 'object' ? data : {};
        let result = new TenantListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Status"] = this.status;
        data["USDOT"] = this.uSDOT;
        data["EIN"] = this.eIN;
        data["Address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["IsMaintenance"] = this.isMaintenance;
        return data;
    }

    clone(): TenantListModel {
        const json = this.toJSON();
        let result = new TenantListModel();
        result.init(json);
        return result;
    }
}

export interface ITenantListModel {
    id?: number;
    name?: string | undefined;
    status?: TenantStatus;
    uSDOT?: number;
    eIN?: number;
    address?: Address | undefined;
    createdAt?: moment.Moment;
    isMaintenance?: boolean;
}

export class TenantAdminListModel extends TenantListModel implements ITenantAdminListModel {
    organizationName?: string | undefined;
    serverName?: string | undefined;
    serverDb?: string | undefined;
    serverSchema?: string | undefined;

    constructor(data?: ITenantAdminListModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organizationName = _data["OrganizationName"];
            this.serverName = _data["ServerName"];
            this.serverDb = _data["ServerDb"];
            this.serverSchema = _data["ServerSchema"];
        }
    }

    static override fromJS(data: any): TenantAdminListModel {
        data = typeof data === 'object' ? data : {};
        let result = new TenantAdminListModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OrganizationName"] = this.organizationName;
        data["ServerName"] = this.serverName;
        data["ServerDb"] = this.serverDb;
        data["ServerSchema"] = this.serverSchema;
        super.toJSON(data);
        return data;
    }

    clone(): TenantAdminListModel {
        const json = this.toJSON();
        let result = new TenantAdminListModel();
        result.init(json);
        return result;
    }
}

export interface ITenantAdminListModel extends ITenantListModel {
    organizationName?: string | undefined;
    serverName?: string | undefined;
    serverDb?: string | undefined;
    serverSchema?: string | undefined;
}

/** 1 = Pending 2 = Created 3 = Live 4 = Suspended 5 = Deactivated */
export enum TenantStatus {
    Pending = 1,
    Created = 2,
    Live = 3,
    Suspended = 4,
    Deactivated = 5,
}

export class Address implements IAddress {
    street?: string | undefined;
    street2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipcode?: string | undefined;
    country?: string | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.street = _data["Street"];
            this.street2 = _data["Street2"];
            this.city = _data["City"];
            this.state = _data["State"];
            this.zipcode = _data["Zipcode"];
            this.country = _data["Country"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Street"] = this.street;
        data["Street2"] = this.street2;
        data["City"] = this.city;
        data["State"] = this.state;
        data["Zipcode"] = this.zipcode;
        data["Country"] = this.country;
        return data;
    }

    clone(): Address {
        const json = this.toJSON();
        let result = new Address();
        result.init(json);
        return result;
    }
}

export interface IAddress {
    street?: string | undefined;
    street2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipcode?: string | undefined;
    country?: string | undefined;
}

export class DataListGetParamsOfTenantAdminListFilters implements IDataListGetParamsOfTenantAdminListFilters {
    filter?: TenantAdminListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfTenantAdminListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? TenantAdminListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfTenantAdminListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfTenantAdminListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfTenantAdminListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfTenantAdminListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfTenantAdminListFilters {
    filter?: TenantAdminListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class TenantListFilters implements ITenantListFilters {
    search?: string | undefined;

    constructor(data?: ITenantListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
        }
    }

    static fromJS(data: any): TenantListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new TenantListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        return data;
    }

    clone(): TenantListFilters {
        const json = this.toJSON();
        let result = new TenantListFilters();
        result.init(json);
        return result;
    }
}

export interface ITenantListFilters {
    search?: string | undefined;
}

export class TenantAdminListFilters extends TenantListFilters implements ITenantAdminListFilters {
    name?: string | undefined;
    organizationName?: string | undefined;
    uSDOT?: number | undefined;
    mcNumber?: number | undefined;
    status?: TenantStatus | undefined;
    serverName?: string | undefined;
    serverDb?: string | undefined;

    constructor(data?: ITenantAdminListFilters) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.organizationName = _data["OrganizationName"];
            this.uSDOT = _data["USDOT"];
            this.mcNumber = _data["McNumber"];
            this.status = _data["Status"];
            this.serverName = _data["ServerName"];
            this.serverDb = _data["ServerDb"];
        }
    }

    static override fromJS(data: any): TenantAdminListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new TenantAdminListFilters();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["OrganizationName"] = this.organizationName;
        data["USDOT"] = this.uSDOT;
        data["McNumber"] = this.mcNumber;
        data["Status"] = this.status;
        data["ServerName"] = this.serverName;
        data["ServerDb"] = this.serverDb;
        super.toJSON(data);
        return data;
    }

    clone(): TenantAdminListFilters {
        const json = this.toJSON();
        let result = new TenantAdminListFilters();
        result.init(json);
        return result;
    }
}

export interface ITenantAdminListFilters extends ITenantListFilters {
    name?: string | undefined;
    organizationName?: string | undefined;
    uSDOT?: number | undefined;
    mcNumber?: number | undefined;
    status?: TenantStatus | undefined;
    serverName?: string | undefined;
    serverDb?: string | undefined;
}

export class DataListResultOfOrganizationListModel implements IDataListResultOfOrganizationListModel {
    items?: OrganizationListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfOrganizationListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(OrganizationListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfOrganizationListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfOrganizationListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfOrganizationListModel {
        const json = this.toJSON();
        let result = new DataListResultOfOrganizationListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfOrganizationListModel {
    items?: OrganizationListModel[] | undefined;
    count?: number;
}

export class OrganizationListModel implements IOrganizationListModel {
    id?: number;
    name?: string | undefined;
    active?: boolean;
    createdAt?: moment.Moment;
    tenants?: number;

    constructor(data?: IOrganizationListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.active = _data["Active"];
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
            this.tenants = _data["Tenants"];
        }
    }

    static fromJS(data: any): OrganizationListModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Active"] = this.active;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["Tenants"] = this.tenants;
        return data;
    }

    clone(): OrganizationListModel {
        const json = this.toJSON();
        let result = new OrganizationListModel();
        result.init(json);
        return result;
    }
}

export interface IOrganizationListModel {
    id?: number;
    name?: string | undefined;
    active?: boolean;
    createdAt?: moment.Moment;
    tenants?: number;
}

export class DataListGetParamsOfOrganizationListFilters implements IDataListGetParamsOfOrganizationListFilters {
    filter?: OrganizationListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfOrganizationListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? OrganizationListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfOrganizationListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfOrganizationListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfOrganizationListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfOrganizationListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfOrganizationListFilters {
    filter?: OrganizationListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class OrganizationListFilters implements IOrganizationListFilters {
    name?: string | undefined;
    active?: boolean | undefined;

    constructor(data?: IOrganizationListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.active = _data["Active"];
        }
    }

    static fromJS(data: any): OrganizationListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Active"] = this.active;
        return data;
    }

    clone(): OrganizationListFilters {
        const json = this.toJSON();
        let result = new OrganizationListFilters();
        result.init(json);
        return result;
    }
}

export interface IOrganizationListFilters {
    name?: string | undefined;
    active?: boolean | undefined;
}

export class OrganizationNewModel implements IOrganizationNewModel {
    name?: string | undefined;
    ownerName?: string | undefined;
    ownerEmail?: string | undefined;

    constructor(data?: IOrganizationNewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.ownerName = _data["OwnerName"];
            this.ownerEmail = _data["OwnerEmail"];
        }
    }

    static fromJS(data: any): OrganizationNewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationNewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["OwnerName"] = this.ownerName;
        data["OwnerEmail"] = this.ownerEmail;
        return data;
    }

    clone(): OrganizationNewModel {
        const json = this.toJSON();
        let result = new OrganizationNewModel();
        result.init(json);
        return result;
    }
}

export interface IOrganizationNewModel {
    name?: string | undefined;
    ownerName?: string | undefined;
    ownerEmail?: string | undefined;
}

export class OrganizationDetailsModel extends OrganizationListModel implements IOrganizationDetailsModel {

    constructor(data?: IOrganizationDetailsModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OrganizationDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationDetailsModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): OrganizationDetailsModel {
        const json = this.toJSON();
        let result = new OrganizationDetailsModel();
        result.init(json);
        return result;
    }
}

export interface IOrganizationDetailsModel extends IOrganizationListModel {
}

export class DataListResultOfUserListModel implements IDataListResultOfUserListModel {
    items?: UserListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfUserListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(UserListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfUserListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfUserListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfUserListModel {
        const json = this.toJSON();
        let result = new DataListResultOfUserListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfUserListModel {
    items?: UserListModel[] | undefined;
    count?: number;
}

export class UserListModel implements IUserListModel {
    id?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    emailConfirmed?: boolean;
    userType?: UserType;
    organizationId?: number | undefined;
    organizationName?: string | undefined;
    createdAt?: moment.Moment;
    lockoutEnd?: moment.Moment | undefined;
    lastSignedIn?: moment.Moment | undefined;
    lastChangedPassword?: moment.Moment | undefined;
    phone?: string | undefined;

    constructor(data?: IUserListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fullName = _data["FullName"];
            this.email = _data["Email"];
            this.emailConfirmed = _data["EmailConfirmed"];
            this.userType = _data["UserType"];
            this.organizationId = _data["OrganizationId"];
            this.organizationName = _data["OrganizationName"];
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
            this.lockoutEnd = _data["LockoutEnd"] ? moment(_data["LockoutEnd"].toString()) : <any>undefined;
            this.lastSignedIn = _data["LastSignedIn"] ? moment(_data["LastSignedIn"].toString()) : <any>undefined;
            this.lastChangedPassword = _data["LastChangedPassword"] ? moment(_data["LastChangedPassword"].toString()) : <any>undefined;
            this.phone = _data["Phone"];
        }
    }

    static fromJS(data: any): UserListModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FullName"] = this.fullName;
        data["Email"] = this.email;
        data["EmailConfirmed"] = this.emailConfirmed;
        data["UserType"] = this.userType;
        data["OrganizationId"] = this.organizationId;
        data["OrganizationName"] = this.organizationName;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["LockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : <any>undefined;
        data["LastSignedIn"] = this.lastSignedIn ? this.lastSignedIn.toISOString() : <any>undefined;
        data["LastChangedPassword"] = this.lastChangedPassword ? this.lastChangedPassword.toISOString() : <any>undefined;
        data["Phone"] = this.phone;
        return data;
    }

    clone(): UserListModel {
        const json = this.toJSON();
        let result = new UserListModel();
        result.init(json);
        return result;
    }
}

export interface IUserListModel {
    id?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    emailConfirmed?: boolean;
    userType?: UserType;
    organizationId?: number | undefined;
    organizationName?: string | undefined;
    createdAt?: moment.Moment;
    lockoutEnd?: moment.Moment | undefined;
    lastSignedIn?: moment.Moment | undefined;
    lastChangedPassword?: moment.Moment | undefined;
    phone?: string | undefined;
}

export class DataListGetParamsOfAdminUserListFilters implements IDataListGetParamsOfAdminUserListFilters {
    filter?: AdminUserListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfAdminUserListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? AdminUserListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfAdminUserListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfAdminUserListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfAdminUserListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfAdminUserListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfAdminUserListFilters {
    filter?: AdminUserListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class UserListFilters implements IUserListFilters {
    search?: string | undefined;
    isLocked?: boolean | undefined;
    userType?: UserType | undefined;
    emailConfirmed?: boolean | undefined;

    constructor(data?: IUserListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
            this.isLocked = _data["IsLocked"];
            this.userType = _data["UserType"];
            this.emailConfirmed = _data["EmailConfirmed"];
        }
    }

    static fromJS(data: any): UserListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new UserListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        data["IsLocked"] = this.isLocked;
        data["UserType"] = this.userType;
        data["EmailConfirmed"] = this.emailConfirmed;
        return data;
    }

    clone(): UserListFilters {
        const json = this.toJSON();
        let result = new UserListFilters();
        result.init(json);
        return result;
    }
}

export interface IUserListFilters {
    search?: string | undefined;
    isLocked?: boolean | undefined;
    userType?: UserType | undefined;
    emailConfirmed?: boolean | undefined;
}

export class AdminUserListFilters extends UserListFilters implements IAdminUserListFilters {
    organizationId?: number | undefined;

    constructor(data?: IAdminUserListFilters) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organizationId = _data["OrganizationId"];
        }
    }

    static override fromJS(data: any): AdminUserListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserListFilters();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OrganizationId"] = this.organizationId;
        super.toJSON(data);
        return data;
    }

    clone(): AdminUserListFilters {
        const json = this.toJSON();
        let result = new AdminUserListFilters();
        result.init(json);
        return result;
    }
}

export interface IAdminUserListFilters extends IUserListFilters {
    organizationId?: number | undefined;
}

export class CodedExceptionApi extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isCodedExceptionApi = true;

    static isCodedExceptionApi(obj: any): obj is CodedExceptionApi {
        return obj.isCodedExceptionApi === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new CodedExceptionApi(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}